<template>
    <div id="changeWhProject">
        <a-modal
            v-model="visible"
            :title="$t('asnPage.changeWhProjectTitle')"
            @ok="confirm"
            @cancel="visible = false"
            :okText="$t('publicLang.Confirm')"
            :cancelText="$t('publicLang.Cancel')"
        >
            <a-form-item :label="$t('asnPage.changeWhProjectLabel')" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-select
                    show-search
                    optionFilterProp="children"
                    size="small"
                    v-model="selectedValue"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    style="width: 100%"
                >
                    <a-select-option v-for="item in options" :key="item.code" :value="item.code">
                        {{ item.code }}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-modal>
    </div>
</template>

<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";

export default {
    data() {
        return {
            visible: false,
            selectedValue: undefined,
            options: [],
            keyList: [],
            validateApi: "",
            changeApi: "",
            listKey: "ref01List",
        };
    },
    methods: {
        /**
         * @param {Array} uids - uid list of selected orders
         * @param {String} validateApi - validate API url, default ASN_VALIDATE_CHANGE_WH_PROJECT
         * @param {String} changeApi - change API url, default ASN_CHANGE_WH_PROJECT
         * @param {String} listKey - param key used by validate/change API, default 'ref01List'
         */
        show(uids, validateApi, changeApi, listKey) {
            this.validateApi = validateApi || api.ASN_VALIDATE_CHANGE_WH_PROJECT;
            this.changeApi = changeApi || api.ASN_CHANGE_WH_PROJECT;
            this.listKey = listKey || "ref01List";
            this.selectedValue = undefined;
            this.options = [];
            this.keyList = [];
            ajax.post(this.validateApi, { uids: uids || [] }).then(res => {
                if (res.code == 200) {
                    this.options = res.data.options || [];
                    this.keyList = res.data[this.listKey] || [];
                    this.visible = true;
                } else {
                    this.$customMessage.warning(res.msg, 3);
                }
            });
        },
        confirm() {
            if (!this.selectedValue) {
                this.$customMessage.warning(this.$t('asnPage.pleaseSelectTargetProject'), 3);
                return;
            }
            let selectedItem = this.options.find(item => item.code === this.selectedValue);
            if (!selectedItem) {
                this.$customMessage.warning(this.$t('asnPage.targetProjectNotExist'), 3);
                return;
            }
            let params = {
                projectCode: this.selectedValue,
            };
            params[this.listKey] = this.keyList;
            ajax.post(this.changeApi, params).then(res => {
                if (res.code == 200) {
                    this.$message.success(res.msg || 'Success');
                    this.visible = false;
                    this.$emit('success');
                } else {
                    this.$customMessage.error(res.msg);
                }
            });
        },
    },
};
</script>
